<template>
    <div>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    :items="dataItems"
                    :label="$t('Gráficos')"
                    item-text="label"
                    item-value="val"
                    outlined
                    v-model="typeGraph"
                    @change="changeTypeGraph"
                    multiple
                    chips
                    :disabled="dataItems.length==1"
                ></v-select>
            </v-col>
        </v-row>

        <!-- graphics -->
        <v-row>
            <v-col cols="12">
                <products-prices v-if="showGraph" :type="typeGraph" :money="money"/>
            </v-col>
            <v-col cols="12">
                <categories-prices v-if="showGraph" :type="typeGraph" :money="money"/>
            </v-col>
            <v-col cols="12">
                <products-units v-if="showGraph" :type="typeGraph"/>
            </v-col>
            <v-col cols="12">
                <categories-units v-if="showGraph" :type="typeGraph"/>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            overlay: true,
            showGraph: false,
            typeGraph: ['orders'],
            dataItems: [
                {val: 'orders', label: 'Ventas digitales'},
                // {val: 'sales', label:'Puntos de venta'},
                // {val: 'presales', label:'Preventas'},
            ]
        }
    },
    props: ['money', 'slug'],
    created() {
        this.getVisibleItems()
    },
    mounted() {
        setTimeout(() => {
            this.showGraph = true
            this.overlay = false
        }, 300);
    },
    methods: {
        async getVisibleItems() {
            await axios.get(`/admin/visible-items/?slug=${this.slug}`)
            .then((response) => {
                // console.log(response.data);
                if (response.data.sales>0) {
                    this.dataItems.push({val: 'sales', label: this.$t('Puntos de venta')})
                }
                if (response.data.presales>0) {
                    this.dataItems.push({val: 'presales', label: this.$t('Preventas')})
                }
                if (response.data.physicalSales>0) {
                    this.dataItems.push({val: 'internal-sales', label: this.$t('Ventas físicas')})
                }

            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        changeTypeGraph(e) {
            this.showGraph = false
            this.overlay = true
            this.typeGraph = e
            setTimeout(() => {
                this.showGraph = true
                this.overlay = false
            }, 300);
        }
    },
}
</script>
